import { ApiClaim } from 'services/backofficeIntegration/http/endpoints/fact-grabbing/httpGetClaimsByText';
import { create } from 'zustand';

type UseFactGrabbingStoreState = {
  claimsCache: Record<string, ApiClaim[]>;
  isLoading: boolean;
  hasError: boolean;
};

type UseFactGrabbingStoreActions = {
  setClaims: (text: string, claims: ApiClaim[]) => void;
  setLoading: (isLoading: boolean) => void;
  setError: (hasError: boolean) => void;
  getCachedClaims: (text: string) => ApiClaim[] | null;
};

export const useFactGrabbingStore = create<UseFactGrabbingStoreState & UseFactGrabbingStoreActions>(
  (set, get) => ({
    claimsCache: {},
    isLoading: false,
    hasError: false,
    setClaims: (text, claims) => {
      set(state => ({
        claimsCache: {
          ...state.claimsCache,
          [text]: claims
        }
      }));
    },
    setLoading: isLoading => {
      set({ isLoading });
    },
    setError: hasError => {
      set({ hasError });
    },
    getCachedClaims: text => {
      return get().claimsCache[text] || null;
    }
  })
);
